import Mustache from 'mustache'
import riderMessages from 'core/data-model/constants/validation-messages'
import { formatNumber } from 'core/service/lib/number-format'

export const invalidSumAssuredRule = (rule, eligibilities) => {
  let errorMessage = ''

  if (eligibilities.basicSumAssured > 0 && eligibilities.basicSumAssured <= rule.validSumassured) {
    errorMessage = Mustache.render(riderMessages.RULE_RIDER_SUM_ASSURED, {
      minimumSumassured: formatNumber(rule.validSumassured),
    })
  }

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
